import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api.js";
import type { Survey, SurveyQuestion, SurveyChoice } from "@templestay/db";

export type SurveyQuestionWithChoices = SurveyQuestion & { choices: SurveyChoice[] };

export type ActiveSurveyResponse = {
  survey: Survey | null;
  questions: SurveyQuestionWithChoices[];
};

export function useActiveSurvey(slug?: string) {
  return useQuery({
    queryKey: ["survey", slug ?? "active"],
    queryFn: () =>
      slug
        ? api.get<ActiveSurveyResponse>(`/api/surveys/slug/${slug}`)
        : api.get<ActiveSurveyResponse>("/api/surveys/active"),
    staleTime: 1000 * 60 * 5,
  });
}
